import { http } from '@pendo/http';

export const labelsApi = '/api/s/_SID_/label';

export const shareApi = '/api/s/_SID_/share/ItemGroup';

export function fetchLabels () {
    return http.get(labelsApi);
}

export function createLabel (name, isPrivate) {
    return http.post(`${labelsApi}?uniqueforuser=${isPrivate}`, { name });
}

export function editLabel ({ labelId, labelName }) {
    return http.patch(`${labelsApi}/${labelId}`, { name: labelName });
}

export async function createPublicLabel (labelId) {
    try {
        const publicLabel = await http.post(`${shareApi}/${labelId}`, { scope: 'global', level: 'owner' });

        return publicLabel;
    } catch (error) {
        // if creating the public label fails, delete the private version and give an error message
        await deleteLabel(labelId);
        throw error;
    }
}

export function createLabelOnEntity (name, isPrivate, memberId, memberType) {
    return http.post(`${labelsApi}?uniqueforuser=${isPrivate}`, { name, members: [{ memberId, memberType }] });
}

export function addLabel (labelId, memberId) {
    return http.put(`${labelsApi}/${labelId}/member/${memberId}`);
}

export function removeLabel (labelId, memberId) {
    return http.delete(`${labelsApi}/${labelId}/member/${memberId}`);
}

export function addLabelToEntity (labelId, memberId, memberType) {
    return http.patch(`${labelsApi}/${labelId}/add`, {
        members: [{ memberId, memberType }],
    });
}

export function removeLabelFromEntity (labelId, memberId, memberType) {
    return http.patch(`${labelsApi}/${labelId}/remove`, {
        members: [{ memberId, memberType }],
    });
}

export function deleteLabel (labelId) {
    return http.delete(`${labelsApi}/${labelId}`);
}

export function getLabel (labelId) {
    return http.get(`${labelsApi}/${labelId}`);
}
